export const HANDLEACTIVE = "HANDLEACTIVE";

export const handleActive = (active: number) => {
  return async (dispatch: any) => {
    dispatch({
      type: HANDLEACTIVE,
      aba: active,
    });
  };
};
